import styled from "styled-components";
import { LinearProgress } from '@mui/material';
import QueryStatsIcon from '@mui/icons-material/QueryStats';

export const FundraisingCardContainer = styled.div`
  background-color: #f6f4f4;
  border-radius: 10px;
  height: 16rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;
  padding: 1rem;
  box-sizing: border-box;
`;

export const Card = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    background: #ffffff;
    box-shadow: 0px 3.79451px 3.79451px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    padding-left: 0.75rem;
    cursor: pointer;
`;

export const CardTitle = styled.p`
    width: 100%;
    margin-top: 0.25rem;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const CardNumber = styled.p`
    color: #fe2f67;
    font-weight: 600;
    font-size: 25px;
`;

export const CardTag = styled.p`
    font-weight: 500;
    font-size: 14px;
`;

export const ProgressBar = styled(LinearProgress)`
    & .MuiLinearProgress-bar {
        background-color: rgba(254, 47, 103, 1);
    }
    background-color: rgba(254, 47, 103, 0.09) !important;
    border-radius: 10px;
    min-height: 20px;
    width: 95%;
`;

export const CardSubTag = styled.p`
    font-weight: 500;
    font-size: 12px;
    color: #606770;
`;

export const CardSubTitle = styled.p`
    font-weight: 500;
    font-size: 14px;
`;

export const CardSection = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
`;

export const CardSubSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    width: 100%;
`;

export const CardIcon = styled(QueryStatsIcon)`
    margin-right: 1rem;
    color: rgba(254, 47, 103, 1);
    &:hover {
        cursor: pointer;
        color: rgba(254, 47, 103, 0.5);
    }
`;
